import { Claude } from "./components/Claude";
import { Close, Fit, Footer, Pricing } from "./components/Closing";
import { Hero } from "./components/Hero";
import { Links } from "./components/Links";
import { Nav } from "./components/Nav";
import { PlainEnglish } from "./components/PlainEnglish";
import { Scenarios } from "./components/Scenarios";
import { World } from "./components/World";

export function App() {
	return (
		<>
			<a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:bg-paper focus:px-3 focus:py-2">
				Skip to content
			</a>
			<Nav />
			<main id="main">
				<Hero />
				<Links />
				<Claude />
				<Scenarios />
				<World />
				<PlainEnglish />
				<Fit />
				<Pricing />
				<Close />
			</main>
			<Footer />
		</>
	);
}
